var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifyMappingUnlockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.323,
    height: 16.879,
    viewBox: "0 0 15.323 16.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-unlock",
    "data-name": "Icon feather-unlock",
    transform: "translate(-3.75 -2.227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16234",
    "data-name": "Path 16234",
    d: "M6.036,16.5H16.787a1.536,1.536,0,0,1,1.536,1.536v5.376a1.536,1.536,0,0,1-1.536,1.536H6.036A1.536,1.536,0,0,1,4.5,23.412V18.036A1.536,1.536,0,0,1,6.036,16.5Z",
    transform: "translate(0 -6.592)",
    fill: "none",
    stroke: "#1984bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16235",
    "data-name": "Path 16235",
    d: "M10.5,9.908V6.836a3.84,3.84,0,0,1,7.6-.768",
    transform: "translate(-2.928)",
    fill: "none",
    stroke: "#1984bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyMappingUnlockIcon);
export default __webpack_public_path__ + "static/media/verifyMapping-unlockIcon.a9074a4443067fc8e12dbaa00e1c8a38.svg";
export { ForwardRef as ReactComponent };